// extracted by mini-css-extract-plugin
export default {"tagHeading":"DC1FODwU"};